import React, { useState, useEffect } from "react";
import { getData, postData } from "../api/protectedApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SettingLayout from "../component/layout/SettingLayout";
import OtpModalForm from "../component/ui/OtpModalForm";
import { formatDate } from "../utils/tableUtils";
import { handleCopy } from "../utils/handleCopy";
import layoutStyles from "../component/layout/css/settingLayout.module.css";
import { callDataByEndpoint } from "../utils/dataUtils";

const WhiteListIp = () => {
  const [ipList, setIpList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpTimer, setOtpTimer] = useState(0);
  const [otp, setOtp] = useState("");
  const [ip, setIp] = useState("");
  const [loading, setLoading] = useState(false);
  const [copiedText, setCopiedText] = useState(null);

  const fetchIpList = () => {
    callDataByEndpoint("/user/whitelist_ip_list", {
      method: "GET",
      setData: setIpList,
    });
  };

  useEffect(() => {
    fetchIpList();
  }, []);

  const handleForm = async () => {
    if (!ip || !otp) {
      toast.error("Please fill both IP address and OTP");
      return;
    }

    try {
      setLoading(true);
      const response = await postData("/user/whitelist_ip", {
        otp: otp,
        ip: ip,
      });

      if (response.data.success) {
        toast.success(response.data.message || "IP Whitelisted Successfully");
        setShowModal(false);
        setIp("");
        setOtp("");
        fetchIpList();
      } else {
        toast.error(response.data.message || "Failed to whitelist IP");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while processing the request.");
    } finally {
      setLoading(false);
    }
  };

  const handleGetOtp = async () => {
    try {
      setOtpLoading(true);
      const response = await getData("/user/withrawOtp", {});

      if (response.data.success) {
        toast.success("OTP Sent Successfully!");
        setOtpTimer(120);
      } else {
        toast.error(response.data.message || "Failed to send OTP");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error sending OTP");
    } finally {
      setOtpLoading(false);
    }
  };

  useEffect(() => {
    let timer;
    if (otpTimer > 0) {
      timer = setTimeout(() => setOtpTimer(otpTimer - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [otpTimer]);

  const columns = [
    { key: "id", label: "ID" },
    { key: "ipAddress", label: "IP ADDRESS" },
    { key: "date", label: "DATE" },
  ];

  const modalBody = (
    <OtpModalForm
      subtext="Specify authorized IPv4 / IPv6 addresses and enter the verification OTP."
      customField={
        <div className={layoutStyles.formGroup}>
          <label className={layoutStyles.formLabel}>IPv4 / IPv6 Address</label>
          <input
            type="text"
            className={layoutStyles.customInput}
            placeholder="e.g. 192.168.1.1"
            value={ip}
            onChange={(e) => setIp(e.target.value)}
          />
        </div>
      }
      otp={otp}
      setOtp={setOtp}
      otpLoading={otpLoading}
      otpTimer={otpTimer}
      onGetOtp={handleGetOtp}
      onSubmit={handleForm}
      loading={loading}
      submitText="Authorize & Whitelist IP"
      submitLoadingText="Whitelisting..."
    />
  );

  return (
    <SettingLayout
      heading="IP Whitelist Management"
      subheading="Restrict API access exclusively to authorized server IP addresses."
      buttonText="Whitelist New IP"
      onAddClick={() => setShowModal(true)}
      cardTitle="Whitelisted Server IPs"
      cardSubtitle="Active production server IP registry"
      columns={columns}
      table_data={ipList}
      emptyMessage="No Whitelisted IPs Found."
      showModal={showModal}
      onCloseModal={() => setShowModal(false)}
      modalTitle="Whitelist New IP Address"
      modalBody={modalBody}
    />
  );
};

export default WhiteListIp;
